<template>
  <div class="container-xs">
    <div class="case-creation__step case-creation__patient-information">
      <div class="case-creation__card mb-10">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-patient-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">Add Insurance</h3>
          </div>
        </div>
        <div class="case-creation__body pb-0">
          <div class="vue-form">
            <el-form :model="insuranceData">
              <el-row :gutter="30">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"> Insurance Name </label>

                      <el-input
                        placeholder="Enter Insurance Name"
                        v-model="insuranceData.name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"> Payor Code </label>
                      <el-input
                        placeholder="Enter Payor Code"
                        v-model="insuranceData.payor_electronic_id"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text"> Wave Code </label>
                      <el-input
                        placeholder="Enter Wave Code"
                        v-model="insuranceData.insurance_verification_code"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="case-creation__actions">
            <ul class="list pt-0">
              <li>
                <el-button
                  size="medium"
                  type="default"
                  class="btn cancel-button"
                  @click="goBack"
                  >Cancel</el-button
                >
              </li>
              <li>
                <el-button v-if="this.$route.params.insurance_id"
                  size="medium"
                  type="success"
                  class="btn save-button"
                  @click="updateInsuranceDetails()"
                  :disabled="disableSubmitButton"
                  :loading="submitLoading"
                  >Update</el-button
                >
                <el-button v-else
                  size="medium"
                  type="success"
                  class="btn save-button"
                  @click="submitInsuranceDetails()"
                  :disabled="disableSubmitButton"
                  :loading="submitLoading"
                  >Save</el-button
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      submitLoading: false,
      insuranceData: {
        status: "ACTIVE",
        insurance_verification_code: "",
        name: "",
        payor_electronic_id: "",
        health_insurance_type: "OTHER",
      },
    };
  },
  computed: {
    ...mapGetters("insurances", [
      "getInsuranceCreationStatus",
      "getInsuranceDetails",
      "getUpdateInsuranceStatus"
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    disableSubmitButton() {
      if (
        !this.insuranceData.name &&
        !this.insuranceData.payor_electronic_id &&
        !this.insuranceData.insurance_verification_code
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.$route.params.insurance_id) {
      this.fetchInsuranceById(this.$route.params.insurance_id);
    }
  },
  methods: {
    async updateInsuranceDetails() {
      try {
        let insurance = this.$route.params.insurance_id
        let insuranceData =  this.insuranceData
        await this.$store.dispatch(
          "insurances/updateInsurance",
          {insuranceData,insurance}
        );
        if (this.getUpdateInsuranceStatus) {
          successNotification("Insurance updated successfully");
          this.insuranceData = {};
          this.cancelInsurance()
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while updating insurance");
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fetchInsuranceById(insurance) {
      let params = {
        insurance_id: insurance,
      };
      await this.$store.dispatch("insurances/getInsuranceById", params);
      if (this.getInsuranceDetails && this.getInsuranceDetails.data) {
        this.insuranceData.name = this.getInsuranceDetails.data.name || ""
        this.insuranceData.payor_electronic_id = this.getInsuranceDetails.data.payor_electronic_id || ""
        this.insuranceData.insurance_verification_code = this.getInsuranceDetails.data.insurance_verification_code || ""
      }
    },
    async submitInsuranceDetails() {
      try {
        await this.$store.dispatch(
          "insurances/createInsurance",
          this.insuranceData
        );
        if (this.getInsuranceCreationStatus) {
          successNotification("Insurance added successfully");
          this.insuranceData = {};
          this.cancelInsurance()
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while adding insurance");
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async cancelInsurance() {
      this.$router.push({
        name: "AllInsurances",
      });
    },
    goBack() {
      if (Object.keys(this.insuranceData).length === 0) {
        this.clearDataAndGoToInsurances();
      } else {
        this.$confirm(
          `Are you sure to cancel ${this.$route.params.insurance_id ? "updating" : "adding new"} Insurance?`,
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {
          this.cancelInsurance();
        });
      }
    },
    clearDataAndGoToInsurances() {
      this.insuranceData = {};
      this.goToInsurances();
    },
    goToInsurances() {
      this.$router.push({ name: "AllInsurances" });
    },
  },
};
</script>
